import { TweenLite } from "gsap";

class SocialButtons {
  constructor() {
    this.lang = document.body.dataset.lang;

    const langUrl = this.lang === "fr" ? "" : "/en";

    this.url = "http://www.emma-the-story.com" + langUrl;

    this.duration = 1.5;
    this.overDuration = 0.8;
    this.itemWidth = 20;
    this.itemOutOpacity = 0.4;
    this.container = document.querySelector(".section-hero__social");
    this.fatLine = this.container.querySelector(
      ".section-hero__social__lines__large"
    );
    this.smallLineContainer = this.container.querySelector(
      ".section-hero__social__lines__small-container"
    );
    this.smallLine = this.container.querySelector(
      ".section-hero__social__lines__small-container__line"
    );
    this.facebookBtn = this.container.querySelector(
      ".section-hero__social__li--facebook"
    );
    this.twitterBtn = this.container.querySelector(
      ".section-hero__social__li--twitter"
    );
  }

  init() {
    this.initFatLine();
    this.initSmallLine();
    this.initButtons();
    this.initEvents();
  }

  initFatLine() {
    TweenLite.to(this.fatLine, this.duration, {
      width: 100 + "%",
      ease: Quint.easeInOut,
      force3D: true
    });
  }

  initSmallLine() {
    TweenLite.to(this.smallLine, this.duration, {
      top: 0 + "px",
      opacity: 1,
      delay: 0.2,
      ease: Quint.easeInOut,
      force3D: true
    });
    TweenLite.to(this.smallLineContainer, 0, { opacity: 0 });
  }

  initButtons() {
    TweenLite.to(this.facebookBtn, this.duration, {
      y: 0 + "px",
      opacity: 1,
      scale: 1,
      delay: 0.1,
      ease: Quint.easeInOut,
      force3D: true
    });
    TweenLite.to(this.twitterBtn, this.duration, {
      y: 0 + "px",
      opacity: 1,
      scale: 1,
      delay: 0.3,
      ease: Quint.easeInOut,
      force3D: true
    });
  }

  initEvents() {
    this.twitterBtn.addEventListener("mouseenter", () => {
      this.onOverButton("twitter");
    });

    this.facebookBtn.addEventListener("mouseenter", () => {
      this.onOverButton("facebook");
    });

    this.container.addEventListener("mouseleave", () => {
      this.onOut();
    });

    this.facebookBtn.addEventListener("click", () => {
      this.onShareFb();
    });

    this.twitterBtn.addEventListener("click", () => {
      this.onShareTw();
    });
  }

  onShareFb() {
    FB.ui(
      {
        method: "share",
        href: this.url
      },
      function(response) {
        console.log("response", response);
      }
    );
  }

  onOut() {
    TweenLite.to(this.twitterBtn, this.overDuration, {
      opacity: 1,
      ease: Quint.easeInOut
    });
    TweenLite.to(this.facebookBtn, this.overDuration, {
      opacity: 1,
      ease: Quint.easeInOut
    });

    TweenLite.to(this.smallLineContainer, this.overDuration, { opacity: 0 });
  }

  onShareTw() {
    const textFr =
      "Elliott est paralysé par le doute. Demain, il doit rejoindre Emma, loin, très lo" +
      "in d'ici. Découvrez EMMA un roman graphique animé disponible sur iOS, android, P" +
      "C et MAC.";
    const textEn =
      "Elliott is paralyzed by doubt. Tomorrow he must go to Emma, far, far away from h" +
      "ere. Discover EMMA, an animated graphic novel available for iOS, Android, PC and" +
      " Mac.";
    const text = this.lang === "fr" ? textFr : textEn,
      url =
        "https://twitter.com/share?url=" +
        "http://onelink.to/xgbts2" +
        "&via=cineteve_exp&text=" +
        text;
    window.open(url, "_blank");

    return false;
  }

  onOverButton(btn) {
    switch (btn) {
      case "twitter":
        TweenLite.to(this.twitterBtn, this.overDuration, {
          opacity: 1,
          ease: Quint.easeInOut
        });
        TweenLite.to(this.facebookBtn, this.overDuration, {
          opacity: this.itemOutOpacity,
          ease: Quint.easeInOut
        });
        TweenLite.to(this.smallLineContainer, this.overDuration, {
          x: 30,
          opacity: 1,
          ease: Quint.easeInOut
        });
        break;
      case "facebook":
        TweenLite.to(this.facebookBtn, this.overDuration, {
          opacity: 1,
          ease: Quint.easeInOut
        });
        TweenLite.to(this.twitterBtn, this.overDuration, {
          opacity: this.itemOutOpacity,
          ease: Quint.easeInOut
        });
        TweenLite.to(this.smallLineContainer, this.overDuration, {
          x: 0,
          opacity: 1,
          ease: Quint.easeInOut
        });
        break;
    }
  }
}

export default SocialButtons;



// WEBPACK FOOTER //
// ./src/js/components/SocialButtons.js